var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Styled } from './style';
var AppStoreCategoryTitle = /** @class */ (function (_super) {
    __extends(AppStoreCategoryTitle, _super);
    function AppStoreCategoryTitle(props) {
        return _super.call(this, props) || this;
    }
    AppStoreCategoryTitle.prototype.count = function () {
        if (this.props.count && this.props.count > 0) {
            return React.createElement("span", { className: "count" }, this.props.count);
        }
        return;
    };
    AppStoreCategoryTitle.prototype.render = function () {
        return (React.createElement(Styled, { className: "category-title" },
            React.createElement("h2", { className: "title" },
                this.props.title,
                " ",
                this.count())));
    };
    AppStoreCategoryTitle.defaultProps = {
        title: 'All Apps',
    };
    return AppStoreCategoryTitle;
}(React.Component));
export default AppStoreCategoryTitle;
//# sourceMappingURL=index.js.map